<template>
  <div class="browser-recommend">
    <div id="browser-header">
      <img id="browser-header-img" :src="require('@/assets/images/browser/img/logo.png')" alt="广联达数字新成本平台"/>
    </div>
    <div id="browser-content">
      <img id="browser-content-img" :src="require('@/assets/images/browser/img/browser-error.png')" alt=""/>
      <p id="browser-content-tip">
        暂不支持此浏览器<br>
        请使用Chrome或360极速浏览器重新打开本网站<br>
        网站链接为：<span id="copyData">https://dcost.glodon.com</span>
      </p>
      <button type="button" class="browser-copyBtn" @click="handlerSuccess" v-clipboard="{value: 'https://dcost.glodon.com', success: handlerSuccess}">
        复制网址
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserRecommend',
  methods: {
    handlerSuccess () {
      this.$message.success('复制成功')
    }
  }
}
</script>

<style scoped>
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    background: #FFFFFF;
  }

  #browser-header {
    width: 100%;
    height: 50px;
    background: #3069c7;
    line-height: 50px;
  }

  #browser-header-img {
    width: 211px;
    height: 50px;
    margin-left: 16px;
  }

  #browser-header-title {
    width: 199px;
    height: 19px;
    font-size: 18px;
    font-family: Roboto, PingFang SC, Segoe UI, "Microsoft YaHei", "微软雅黑", Tahoma, Geneva, sans-serif !important;
    font-weight: 400;
    color: #FFFFFF;
    vertical-align: top;
  }

  #browser-content {
    width: 360px;
    height: 261px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -167px 0 0 -167px;
  }

  #browser-content-tip {
    width: 360px;
    margin-top: 30px;
    font-size: 14px;
    font-family: Roboto, PingFang SC, Segoe UI, "Microsoft YaHei", "微软雅黑", Tahoma, Geneva, sans-serif !important;
    font-weight: 300;
    color: #848484;
    line-height: 30px;
  }

  .browser-copyBtn {
    font-family: Roboto, PingFang SC, Segoe UI, "Microsoft YaHei", "微软雅黑", Tahoma, Geneva, sans-serif !important;
    border: 1px solid #4499FF;
    color: #fff;
    background-color: #4499FF;
    width: 88px;
    height: 32px;
    line-height: 30px;
    border-radius: 4px;
    padding: 0 14px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    -webkit-transition-duration: 0.4s; /* Safari */
    transition-duration: 0.4s;
    cursor: pointer;
  }

  .browser-copyBtn:hover {
    color: #ffffff;
    border-color: #2288FF;
    background-color: #2288FF;
  }

  #copySuccess {
    display: none;
  }
</style>
